import axios from 'axios'
import uuidv4 from 'uuid/v4'
import { detect } from 'detect-browser'

class TrackingService {
  constructor (jwt) {
    this.jwt = jwt
    this.uuid = uuidv4()
    this.browserInfo = detect()
    this.eventOrder = 1
    this.scrolledUpTo = 0
    this.surveyFinished = false
  }

  getScrollPercent () {
    const h = document.documentElement
    const b = document.body
    const st = 'scrollTop'
    const sh = 'scrollHeight'
    const scrollPercentage = (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100
    const flooredPercentage = Math.floor(scrollPercentage / 10) * 10
    return flooredPercentage
  }

  async event (type, data) {
    if (this.surveyFinished) return
    const eventOrder = this.eventOrder
    this.eventOrder++
    return axios.post(`${process.env.SURVEYS_API_URL}/surveys/track`, {
      event: {
          type,
          data
      },
      order: eventOrder,
      uuid: this.uuid,
      browserInfo: this.browserInfo
    }, {
      headers: {
        'Authorization': this.jwt
      }
    })
  }

  async trackScrolling () {
    document.body.onscroll = () => {
      const scrollPercentage = this.getScrollPercent()
      if (this.scrolledUpTo < scrollPercentage) {
        this.scrolledUpTo = scrollPercentage
        if (this.scrolledUpTo > 100) return false
        this.event('scroll', { percentage: scrollPercentage })
      }
    }
  }
}

export default TrackingService



// WEBPACK FOOTER //
// ./src/services/TrackingService.js